export const SWR_MAIN_MIN_SIMULATIONS = 1000;
export const SWR_MAIN_DEFAULT_SIMULATIONS = 3000;
export const SWR_MAIN_MAX_SIMULATIONS = 25000;

export const SWR_SAFE_WITHDRAWAL_ANALYSIS_MODES = {
  quick: {
    id: 'quick',
    label: 'Stima rapida',
    simulations: 500,
  },
  detailed: {
    id: 'detailed',
    label: 'Analisi dettagliata',
    desktopSimulations: 5000,
    mobileSimulations: 5000,
  },
};

export const getSWRSafeWithdrawalDetailedSimulationCount = (isMobile = false) => (
  isMobile
    ? SWR_SAFE_WITHDRAWAL_ANALYSIS_MODES.detailed.mobileSimulations
    : SWR_SAFE_WITHDRAWAL_ANALYSIS_MODES.detailed.desktopSimulations
);

export const getSWRSafeWithdrawalAnalysisModeLabel = (mode) => (
  mode === SWR_SAFE_WITHDRAWAL_ANALYSIS_MODES.detailed.id
    ? SWR_SAFE_WITHDRAWAL_ANALYSIS_MODES.detailed.label
    : SWR_SAFE_WITHDRAWAL_ANALYSIS_MODES.quick.label
);
